const SIGNIN_CALLBACK = 'signin-callback';
const SIGNUP_CALLBACK = 'signup-callback';
const SIGNUP_CPA_CALLBACK = 'signup-cpa-callback';

export default [SIGNIN_CALLBACK, SIGNUP_CALLBACK, SIGNUP_CPA_CALLBACK];
